const media = {
  smUp: '@media (min-width: 576px)',
  smDown: '@media (max-width: 767px)',
  mdUp: '@media (min-width: 768px)',
  lgUp: '@media (min-width: 992px)',
  xlUp: '@media (min-width: 1200px)'
}

export default media



// WEBPACK FOOTER //
// ./src/styles/media.js